import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
button {
  -webkit-appearance: none;
  background: none;
  border: 0;
  box-shadow: none;
  font-family: inherit;
  cursor: pointer;
  width: 100%;
  padding: 0;
}

ul {
  margin-top: 3em;
  padding: 0;
}

li {
  display: inline-block;
  list-style: none;
  margin: 1em auto;
  width: 50%;
  vertical-align: middle;
}

li:nth-of-type(1) {
  text-align: left;
}

li:nth-of-type(2) {
  text-align: right;
}

li:last-of-type {
  width: 75%;
}

.pin-option {
  color: ${colors.primaryText};
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  line-height: 1.2;
}

span {
  margin-left: 0.5em;
}

@media (min-width: 768px) {
  li, li:last-of-type {
    width: 33%;
  }

  li:nth-of-type(1), li:nth-of-type(2) {
    text-align: center;
  }
}
`
